import { Download } from "lucide-react";
import React from "react";
import { useT } from "../i18n/useT";
import { ENABLE_CHART_PNG_EXPORT } from "../lib/exportUtils";

/** Wraps a chart and adds an Export PNG control (gated until export quality is good). */
export function ChartExportFrame({
  title,
  children,
  className,
  onExport,
}: {
  title?: string;
  filename?: string;
  children: React.ReactNode;
  className?: string;
  /** Preferred: branded canvas export. If omitted and flag on, button is hidden. */
  onExport?: () => void;
}) {
  const { t } = useT();
  const showPng = ENABLE_CHART_PNG_EXPORT && !!onExport;

  return (
    <div className={className}>
      <div className="flex items-center justify-between gap-2 mb-2 no-print">
        {title ? <p className="text-sm font-semibold text-foreground">{title}</p> : <span />}
        {showPng && (
          <button
            type="button"
            className="app-btn-outline text-[10px] py-1.5 px-2.5 gap-1"
            onClick={onExport}
          >
            <Download size={12} /> {t("cf.png")}
          </button>
        )}
      </div>
      <div>{children}</div>
    </div>
  );
}
